import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import bundleActions from '@redux/bundle/actions';
import { RootState } from '@redux/reducer';

const { fetchBundleDetailAction } = bundleActions;

const useBundleDetail = () => {
  const dispatch = useDispatch();
  const { bundleDetailSeoState, bundleDetailState } = useSelector((state: RootState) => ({
    bundleDetailSeoState: state.Bundle.get('bundleDetailSeoState'),
    bundleDetailState: state.Bundle.get('bundleDetailState'),
  }));

  const handleFetchBundleDetail = (bundleIdOrIdName: string) => {
    dispatch(fetchBundleDetailAction.request({ bundleIdOrIdName }));
  };

  const handleResetBundleDetail = () => {
    dispatch(fetchBundleDetailAction.reset());
  };

  const { data: bundleDetailSeoData } = bundleDetailSeoState;
  const { data: bundleDetailData, isLoading: isBundleDetailLoading, isError: isBundleDetailError } = bundleDetailState;

  const {
    id,
    idName,
    name,
    hasCourseCPD,
    description,
    courseCardImageUrl,
    price,
    videoCount,
    totalVideoDuration,
    countdownDayType,
    countdownDay,
    attachmentFileCount,
    quizCount,
    articleCount,
    certificateCount,
    courseCount,
    bannerPrimaryColor,
    bannerSecondaryColor,
  } = useMemo(() => {
    return {
      id: bundleDetailSeoData?.id,
      idName: bundleDetailSeoData?.idName,
      name: bundleDetailSeoData?.name,
      hasCourseCPD: bundleDetailSeoData?.hasCourseCPD,
      description: bundleDetailSeoData?.description,
      courseCardImageUrl: bundleDetailData?.courseCardImageUrl,
      price: bundleDetailData?.price,
      videoCount: bundleDetailData?.videoCount,
      totalVideoDuration: bundleDetailData?.totalVideoDuration,
      countdownDayType: bundleDetailData?.countdownDayType,
      countdownDay: bundleDetailData?.countdownDay,
      attachmentFileCount: bundleDetailData?.attachmentFileCount,
      quizCount: bundleDetailData?.quizCount,
      articleCount: bundleDetailData?.articleCount,
      certificateCount: bundleDetailData?.certificateCount,
      courseCount: bundleDetailData?.courseCount,
      bannerPrimaryColor: bundleDetailData?.bannerPrimaryColor,
      bannerSecondaryColor: bundleDetailData?.bannerSecondaryColor,
    };
  }, [bundleDetailSeoData, bundleDetailData]);

  return {
    id,
    idName,
    name,
    hasCourseCPD,
    description,
    courseCardImageUrl,
    price,
    videoCount,
    totalVideoDuration,
    countdownDayType,
    countdownDay,
    attachmentFileCount,
    quizCount,
    articleCount,
    certificateCount,
    courseCount,
    handleFetchBundleDetail,
    handleResetBundleDetail,
    isBundleDetailLoading,
    isBundleDetailError,
    bundleDetailData,
    bannerPrimaryColor,
    bannerSecondaryColor,
  };
};

export default useBundleDetail;
